import { createRouter, createWebHistory } from 'vue-router';
import krRouter from './krRouter';

const routes = [
    {
        path: '',
        component: () => import('../views/kr/landing/LandingView.vue'),
        beforeEnter: (to, from, next) => {
            if(window.location.hostname == 'rnd.kumc.or.kr' && window.location.pathname == '/') {
                return next();
            } else {
                window.location.pathname = '/kr/index.do';
            }
        },
        meta: {
            title : '고려대학교 연구중심병원'
        }
    },
    ...krRouter    
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.afterEach((to, from) => {
    if(location.hostname.split('.')[0].indexOf('anamrnd') > -1){
        document.title = '고려대학교 안암병원 국가지정 연구중심병원';
    }else if(location.hostname.split('.')[0].indexOf('ansanrnd') > -1){
        document.title = '고려대학교 안산병원 연구중심 Cluster';
    }else if(location.hostname.split('.')[0].indexOf('gurornd') > -1){
        document.title = '고려대학교 구로병원 국가지정 연구중심병원';
    }else{
        document.title = '고려대학교 연구중심병원';
    }
});

export default router;
